import apiClient from "@/shared/api/apiClient";

export const getMe = async () => {
  try {
    const { data } = await apiClient.get("/users/me/");
    return data;
  } catch (e) {
    console.error("[session/auth] getMe", e);
  }
};
